import React from "react"
import { Text } from "components/text/Text"
import styled from "styled-components"
import { useBreakpoints } from "src/lib/hooks/use-breakpoints"
import { ArticleElement } from "components/Article/ArticleElement"
import { colors } from "src/styles/colors"

type Props = {
  articles: any
}

const Wrapper = styled.div<any>`
  display: flex;
  flex-direction: column;
  padding: ${({ minTablet }) => (minTablet ? "81px 0" : "34px 0")};
`

const ArticleList = styled.div<any>`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: ${({ minTablet }) => (minTablet ? "row" : "column")};
  & a {
    margin-right: ${({ minTablet }) => (minTablet ? "24px" : 0)};
    margin-bottom: ${({ minTablet }) => (minTablet ? 0 : "32px")};
    &:nth-child(3n + 0) {
      margin-right: 0;
    }
  }
`

export const RecomendedArticles: React.FC<Props> = ({ articles }) => {
  const { minTablet } = useBreakpoints()
  return (
    <Wrapper minTablet={minTablet}>
      <Text
        fontWeight={700}
        size={30}
        color={colors.blueGray}
        textAlign="center"
        style={{
          display: "block",
          marginBottom: minTablet ? 45 : 34,
        }}
      >
        Weitere Artikel für Sie
      </Text>
      <ArticleList minTablet={minTablet}>
        {articles.map((article: any, idx: number) => (
          <ArticleElement {...article} key={idx} />
        ))}
      </ArticleList>
    </Wrapper>
  )
}
